import { render, staticRenderFns } from "./GameTrendChart.vue?vue&type=template&id=2595eeea&scoped=true"
import script from "./GameTrendChart.vue?vue&type=script&lang=js"
export * from "./GameTrendChart.vue?vue&type=script&lang=js"
import style0 from "./GameTrendChart.vue?vue&type=style&index=0&id=2595eeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595eeea",
  null
  
)

export default component.exports